import uuid from 'uuid'
import { Provider } from 'cerebral'

export default Provider({
  id() {
    return uuid.v4()
  }
})



// WEBPACK FOOTER //
// ./src/providers/UuidProvider.js